import { render, staticRenderFns } from "./AcademiaCurso.vue?vue&type=template&id=5762eda8&scoped=true"
import script from "./AcademiaCurso.vue?vue&type=script&lang=js"
export * from "./AcademiaCurso.vue?vue&type=script&lang=js"
import style0 from "./AcademiaCurso.vue?vue&type=style&index=0&id=5762eda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762eda8",
  null
  
)

export default component.exports